
var dlbs = [{"name":"head-dlb/bundle.production.js","path":"head-dlb/static-1.4702/bundle.production.js","ids":{}}];
__webpack_require__.dlbpr = function(dlbId, id) {
  var dlb = dlbs[dlbId];
  if (!dlb.r) {
    dlb.r = window['__webpack_require_' + dlb.name + '__'];
    if (!dlb.r) {
      throw new Error('dlb ' + dlb.name + ' not loaded');
    }
    // the first time a dlb module is required, we link it
    dlb.r.linkDlb(__webpack_require__, dlb.ids);
  }
  return dlb.r(id);
}
